export default __webpack_public_path__ + "static/media/367.563b6e6b.png";